import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  base: (props) => ({
    color: props.color || "inherit",
  }),
  lg: {
    fontSize: "16px",
    lineHeight: "24px",
  },
  md: {
    fontSize: "14px",
    lineHeight: "16px",
  },
  sm: {
    fontSize: "13px",
    lineHeight: "16px",
  },
  xs: {
    fontSize: "12px",
    lineHeight: "16px",
  },
  semibold: {
    fontWeight: 500,
  },
  regular: {
    fontWeight: 400,
  },
  light: {
    fontWeight: 300,
  },
}));
